import React, { useState, useEffect } from 'react';
import { oneKlicks } from '../../../SDK/oneclick';
import { message, notification, Select } from 'antd';
import { toast } from 'react-toastify';
import { getuserdata } from '../../../services/apiService';
import { OneKlicksFileSDK } from '../../../SDK/OneKlicksFileSDK';
import updateBalance from '../../../Uitiles/updateBalance';
import { debugLog } from '../../../utils/debug';    
const EditIncomModel = ({ isOpen, toggle, getIncome, fetchIncome }) => {
    const [transactionType, setTransactionType] = useState('');
    const [incomeType, setIncomeType] = useState('');
    const [errors, setErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [clients, setClients] = useState([]);
    const [usertype, setUsertype] = useState('');
    const [oldbalance, setOldbalance] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitTimeout, setSubmitTimeout] = useState(null);
    const [uploadProgress, setUploadProgress] = useState({});
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

    const [income, setIncome] = useState({
        incomeType: '',
        clientYes: '',
        investorEmail: '',
        investorPhone: '',
        investorName: '',
        otherDetails: '',
        amount: '',
        date: '',
        description: '',
        status: '',
        notes: '',
        attachments: '',
        pickupLocation: '',
        pickupTime: '',
        referenceNumber: '',
        receipt: '',
        toSendAccount: ''
    });

    // Populate form data when getIncome changes
    useEffect(() => {
        if (getIncome && Object.keys(getIncome).length > 0) {
            setTransactionType(getIncome.transactionType || '');
            setIncomeType(getIncome.incomeType || '');
            setOldbalance(getIncome.amount || '');
            
            setIncome({
                incomeType: getIncome.incomeType || '',
                clientYes: getIncome.clientYes || '',
                investorEmail: getIncome.investorEmail || '',
                investorPhone: getIncome.investorPhone || '',
                investorName: getIncome.investorName || '',
                otherDetails: getIncome.otherDetails || '',
                amount: getIncome.amount || '',
                date: getIncome.date || '',
                description: getIncome.description || '',
                status: getIncome.status || '',
                notes: getIncome.notes || '',
                attachments: getIncome.attachments || '',
                pickupLocation: getIncome.pickupLocation || '',
                pickupTime: getIncome.pickupTime || '',
                referenceNumber: getIncome.referenceNumber || '',
                receipt: getIncome.receipt || '',
                toSendAccount: getIncome.toSendAccount || ''
            });
        }
    }, [getIncome]);

    useEffect(() => {
        const fetchClients = async () => {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {};
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const investors = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog('get clients', investors.data);

            if (investors.success === true) {
                setClients(investors.data);
            }

            const usertype = await getuserdata('user_type');
            debugLog('usertype', usertype);
            setUsertype(usertype);
        };
        fetchClients();
    }, []);

    useEffect(() => {
        return () => {
            if (submitTimeout) {
                clearTimeout(submitTimeout);
            }
        };
    }, [submitTimeout]);

    const validateForm = () => {
        const newErrors = {};

        // Validate Income Type
        if (!incomeType) {
            newErrors.incomeType = 'Income type is required';
        }

        // Validate based on Income Type
        if (incomeType === 'investment') {
            if (!income.investorEmail) {
                newErrors.investorEmail = 'Investor email is required';
            } else if (!/\S+@\S+\.\S+/.test(income.investorEmail)) {
                newErrors.investorEmail = 'Invalid email format';
            }

            if (!income.investorPhone) {
                newErrors.investorPhone = 'Investor phone is required';
            } else if (!/^\d{10}$/.test(income.investorPhone)) {
                newErrors.investorPhone = 'Phone must be 10 digits';
            }

            if (!income.investorName) {
                newErrors.investorName = 'Investor name is required';
            }
        }

        if (incomeType === 'other' && !income.otherDetails) {
            newErrors.otherDetails = 'Other details are required';
        }

        if ((incomeType === 'premium' || incomeType === 'client') && !income.clientYes) {
            newErrors.clientYes = 'Please select Yes/No';
        }

        // Validate Transaction Type
        if (!transactionType) {
            newErrors.transactionType = 'Transaction type is required';
        }

        // Validate based on Transaction Type
        if (transactionType === 'cash') {
            if (!income.pickupLocation) {
                newErrors.pickupLocation = 'Pickup location is required';
            }
            if (!income.pickupTime) {
                newErrors.pickupTime = 'Pickup time is required';
            }
        }

        if (transactionType === 'card' || transactionType === 'bank') {
            if (!income.referenceNumber) {
                newErrors.referenceNumber = 'Reference number is required';
            }
            if (!income.receipt) {
                newErrors.receipt = 'Receipt is required';
            }
        }

        // Validate Amount
        if (!income.amount) {
            newErrors.amount = 'Amount is required';
        } else if (isNaN(income.amount) || parseFloat(income.amount) <= 0) {
            newErrors.amount = 'Amount must be greater than 0';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            // Convert FileList to Array for multiple files
            const fileArray = Array.from(files);
            setIncome(prevIncome => ({
                ...prevIncome,
                [name]: fileArray
            }));
        } else {
            setIncome(prevIncome => ({
                ...prevIncome,
                [name]: value
            }));
        }

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleCancel = () => {
        setIncome({
            incomeType: '',
            clientYes: '',
            investorEmail: '',
            investorPhone: '',
            investorName: '',
            otherDetails: '',
            amount: '',
            date: '',
            description: '',
            status: '',
            notes: '',
            attachments: '',
            pickupLocation: '',
            pickupTime: '',
            referenceNumber: '',
            receipt: '',
            toSendAccount: ''
        });
        setIncomeType('');
        setTransactionType('');
        setOldbalance('');
        setSelectedFiles([]);
        setErrors({});
        toggle();
    };

    const validateFile = (file) => {
        if (!ALLOWED_FILE_TYPES.includes(file.type)) {
            throw new Error(`File type ${file.type} is not allowed`);
        }
        if (file.size > MAX_FILE_SIZE) {
            throw new Error(`File size exceeds 5MB limit`);
        }
        return true;
    };

    const uploadMultipleFiles = async (files) => {
        const uploadedFileIds = [];
        const root = "income";
        const status = "public";

        for (const file of files) {
            try {
                // Validate file before upload
                validateFile(file);
                
                // Update progress for this file
                setUploadProgress(prev => ({
                    ...prev,
                    [file.name]: 0
                }));

                // Create FormData for file upload
                const formData = new FormData();
                formData.append('file', file);
                formData.append('root', root);
                formData.append('status', status);

                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file, (progress) => {
                    setUploadProgress(prev => ({
                        ...prev,
                        [file.name]: progress
                    }));
                });

                if (!uploadResult || !uploadResult.fileId) {
                    throw new Error(`Failed to upload file: ${file.name}`);
                }

                uploadedFileIds.push(uploadResult.fileId);
                
                // Clear progress after successful upload
                setUploadProgress(prev => {
                    const newProgress = { ...prev };
                    delete newProgress[file.name];
                    return newProgress;
                });
            } catch (error) {
                debugLog('Error uploading file:', file.name, error);
                // Clear progress on error
                setUploadProgress(prev => {
                    const newProgress = { ...prev };
                    delete newProgress[file.name];
                    return newProgress;
                });
                throw new Error(`Failed to upload file: ${file.name} - ${error.message}`);
            }
        }

        return uploadedFileIds;
    };

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        
        // Validate all files before adding them
        const validFiles = files.filter(file => {
            try {
                validateFile(file);
                return true;
            } catch (error) {
                message.error(error.message);
                toast.error(error.message);
                return false;
            }
        });

        if (validFiles.length === 0) {
            return;
        }

        // Check total size of all files
        const totalSize = validFiles.reduce((sum, file) => sum + file.size, 0);
        const maxTotalSize = 20 * 1024 * 1024; // 20MB total limit

        if (totalSize > maxTotalSize) {
            message.error('Total file size exceeds 20MB limit');
            toast.error('Total file size exceeds 20MB limit');
            return;
        }

        setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
        setIncome(prevIncome => ({
            ...prevIncome,
            attachments: [...prevIncome.attachments, ...validFiles]
        }));
    };

    // Function to remove a file
    const handleRemoveFile = (index) => {
        setSelectedFiles(prevFiles => {
            const newFiles = prevFiles.filter((_, i) => i !== index);
            return newFiles;
        });
        
        setIncome(prevIncome => {
            const newAttachments = prevIncome.attachments.filter((_, i) => i !== index);
            return {
                ...prevIncome,
                attachments: newAttachments
            };
        });

        // Clear progress for removed file
        setUploadProgress(prev => {
            const newProgress = { ...prev };
            delete newProgress[selectedFiles[index]?.name];
            return newProgress;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) {
            message.warning('Please wait, form is being submitted...');
            return;
        }
        
        if (!validateForm()) {
            message.error('Please fix the form errors before submitting');
            return;
        }

        try {
            setIsSubmitting(true);
            setIsUploading(true);

            // Prepare data
            const tableSchema = "";
            const usertype = await getuserdata('user_type');
            const tableName = "income";
            
            // Get user ID first
            const userId = await getuserdata('id');
            if (!userId) {
                throw new Error('User ID not found. Please login again.');
            }

            // Handle file uploads if any
            let attachmentIds = [];
            if (income.attachments && income.attachments.length > 0) {
                try {
                    attachmentIds = await uploadMultipleFiles(income.attachments);
                } catch (error) {
                    throw new Error(`File upload failed: ${error.message}`);
                }
            }

            const data = {
                add_by: userId,
                incomeType: incomeType,
                clientYes: income.clientYes,
                investorEmail: income.investorEmail,
                investorPhone: income.investorPhone,
                investorName: income.investorName,
                otherDetails: income.otherDetails,
                amount: parseFloat(income.amount),
                date: income.date,
                description: income.description,
                status: income.status,
                notes: income.notes,
                attachments: attachmentIds.join(','),
                pickupLocation: income.pickupLocation || "",
                pickupTime: income.pickupTime || "",
                referenceNumber: income.referenceNumber || "",
                receipt: income.receipt || "",
                transactionType: transactionType
            };

            // Validate amount
            if (!data.amount || isNaN(data.amount) || data.amount <= 0) {
                throw new Error('Please enter a valid amount');
            }

            const condition = {
                id: getIncome.id
            };

            // Update income record
            const addIncome = await oneKlicks.update(tableSchema, tableName, data, condition);
            
            if (!addIncome.success) {
                throw new Error(addIncome.message || 'Failed to update income');
            }

            // Handle balance update if amount changed
            if (parseFloat(data.amount) !== parseFloat(oldbalance)) {
                try {
                    debugLog('Updating balance:', {
                        newAmount: data.amount,
                        oldAmount: oldbalance,
                        accountId: getIncome.toSendAccount
                    });


                    const balanceResult = await updateBalance(data.amount, oldbalance, getIncome.toSendAccount, getIncome.id, income, '+');
                    
                    if (!balanceResult.success) {
                        throw new Error('Failed to update balance');
                    }

                    message.success('Balance updated successfully');
                    
                } catch (error) {
                    debugLog('Balance update error:', error);
                    message.warning('Income updated but balance update failed. Please contact support.');
                    toast.warning('Income updated but balance update failed. Please contact support.');
                }
            }

            message.success("Income updated successfully");
            toast.success("Income updated successfully");
            fetchIncome();
            handleCancel();
            if (typeof getIncome === 'function') {
                getIncome();
            }

        } catch (error) {
            debugLog('Error updating income:', error);
            message.error(error.message || 'Failed to update income');
            toast.error(error.message || 'Failed to update income');
        } finally {
            setIsUploading(false);
            setIsSubmitting(false);
        }
    };


    if (!isOpen) return null;
    
    return (
        <div className="modal fade dc-loginformpop show" style={{ display: 'block', paddingRight: '17px', background: '#00000085' }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: '50%', maxWidth: '500px' }}>
                <div className="dc-modalcontent modal-content">
                    <div className="dc-loginformholds" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <div className="dc-loginheader" style={{ paddingLeft: '0px' }}>
                            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Edit Income</span>
                            <a href="#" className="dc-closebtns close dc-close" onClick={handleCancel} aria-label="Close">
                                <i className="fa fa-times"></i>
                            </a>
                        </div>
                        <form onSubmit={handleSubmit} className="dc-html-form" style={{ marginTop: 24 }}>
                            <div className="form-group">
                                <label htmlFor="incomeType"><span style={{ color: 'red' }}>*</span> Income Type</label>
                                <select
                                    id="incomeType"
                                    name="incomeType"
                                    className={`dc-form-control ${errors.incomeType ? 'is-invalid' : ''}`}
                                    required
                                    value={incomeType}
                                    onChange={(e) => {
                                        setIncomeType(e.target.value);
                                        handleInputChange(e);
                                    }}
                                >
                                    <option value="">Select income type</option>
                                    <option value="investment">Investment</option>
                                    <option value="premium">Premium</option>
                                    <option value="client">Client</option>
                                    <option value="other">Other</option>
                                </select>
                                {errors.incomeType && <div className="invalid-feedback">{errors.incomeType}</div>}
                            </div>

                            {incomeType === 'investment' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="investorEmail"><span style={{ color: 'red' }}>*</span> Investor Email</label>
                                        <input
                                            type="email"
                                            id="investorEmail"
                                            name="investorEmail"
                                            className={`dc-form-control ${errors.investorEmail ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Email"
                                            value={income.investorEmail}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorEmail && <div className="invalid-feedback">{errors.investorEmail}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="investorPhone"><span style={{ color: 'red' }}>*</span> Investor Phone</label>
                                        <input
                                            type="tel"
                                            id="investorPhone"
                                            name="investorPhone"
                                            className={`dc-form-control ${errors.investorPhone ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Phone"
                                            value={income.investorPhone}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorPhone && <div className="invalid-feedback">{errors.investorPhone}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="investorName"><span style={{ color: 'red' }}>*</span> Investor Name</label>
                                        <input
                                            type="text"
                                            id="investorName"
                                            name="investorName"
                                            className={`dc-form-control ${errors.investorName ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Name"
                                            value={income.investorName}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorName && <div className="invalid-feedback">{errors.investorName}</div>}
                                    </div>
                                </>
                            )}

                            {(incomeType === 'premium' || incomeType === 'client') && (
                                <div className="form-group">
                                    <label htmlFor="clientYes"><span style={{ color: 'red' }}>*</span> Select Client</label>
                                    <div className="client-selector-container">
                                        <Select
                                            id="clientYes"
                                            name="clientYes"
                                            className={`${errors.clientYes ? 'is-invalid' : ''}`}
                                            placeholder="Select a Client"
                                            value={income.clientYes || undefined}
                                            onChange={(value) => {
                                                setIncome(prev => ({
                                                    ...prev,
                                                    clientYes: value
                                                }));
                                                if (errors.clientYes) {
                                                    setErrors(prev => ({
                                                        ...prev,
                                                        clientYes: ''
                                                    }));
                                                }
                                            }}
                                            options={clients.map(client => ({
                                                value: client.id,
                                                label: `${client.display_name} - ${client.email}`
                                            }))}
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            style={{
                                                width: '100%',
                                                color: '#000000',
                                                backgroundColor: '#ffffff',
                                                height: '44px',
                                                borderColor: '#4e5779',
                                                boxShadow: 'none',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    </div>
                                    {errors.clientYes && <div className="invalid-feedback">{errors.clientYes}</div>}
                                </div>
                            )}

                            {incomeType === 'other' && (
                                <div className="form-group">
                                    <label htmlFor="otherDetails"><span style={{ color: 'red' }}>*</span> Other Details</label>
                                    <input
                                        type="text"
                                        id="otherDetails"
                                        name="otherDetails"
                                        className={`dc-form-control ${errors.otherDetails ? 'is-invalid' : ''}`}
                                        required
                                        placeholder="Enter details"
                                        value={income.otherDetails}
                                        onChange={handleInputChange}
                                    />
                                    {errors.otherDetails && <div className="invalid-feedback">{errors.otherDetails}</div>}
                                </div>
                            )}
                            {usertype === 'administrator' && (
                                <div className="form-group">
                                    <label htmlFor="status"><span style={{ color: 'red' }}>*</span> Status</label>
                                    <select
                                        id="status"
                                        name="status"
                                        className={`dc-form-control ${errors.status ? 'is-invalid' : ''}`}
                                        required
                                        value={income.status}
                                    >
                                        <option value="">Select status</option>
                                        <option value="active">Active</option>
                                        <option value="pending">Pending</option>
                                        <option value="completed">Completed</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="failed">Failed</option>
                                    </select>
                                    {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                                </div>
                            )}

                            <div className='form-group'>
                                <label htmlFor="date"><span style={{ color: 'red' }}>*</span> Date</label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    className={`dc-form-control ${errors.date ? 'is-invalid' : ''}`}
                                    required
                                    value={income.date}
                                    onChange={handleInputChange}
                                />
                                {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="transactionType"><span style={{ color: 'red' }}>*</span> Transaction Type</label>
                                <select
                                    id="transactionType"
                                    name="transactionType"
                                    className={`dc-form-control ${errors.transactionType ? 'is-invalid' : ''}`}
                                    required
                                    value={transactionType}
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        handleInputChange(e);
                                    }}
                                >
                                    <option value="">Select transaction type</option>
                                    <option value="cash">Cash</option>
                                    <option value="cheque">Cheque</option>
                                    <option value="upi">UPI</option>
                                    <option value="rtgs">RTGS</option>
                                    <option value="neft">NEFT</option>
                                    <option value="imps">IMPS</option>
                                    <option value="paytm">Paytm</option>
                                    <option value="phonepe">Phonepe</option>
                                    <option value="amazonpay">Amazon Pay</option>
                                    <option value="paytm">Paytm</option>
                                    <option value="card">Card</option>
                                    <option value="bank">Bank Transfer</option>
                                </select>
                                {errors.transactionType && <div className="invalid-feedback">{errors.transactionType}</div>}
                            </div>

                            {transactionType === 'cash' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="pickupLocation"><span style={{ color: 'red' }}>*</span> Cash Pickup Location</label>
                                        <input
                                            type="text"
                                            id="pickupLocation"
                                            name="pickupLocation"
                                            className={`dc-form-control ${errors.pickupLocation ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter cash pickup location"
                                            value={income.pickupLocation}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupLocation && <div className="invalid-feedback">{errors.pickupLocation}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pickupTime"><span style={{ color: 'red' }}>*</span> Pickup Time</label>
                                        <input
                                            type="datetime-local"
                                            id="pickupTime"
                                            name="pickupTime"
                                            className={`dc-form-control ${errors.pickupTime ? 'is-invalid' : ''}`}
                                            required
                                            value={income.pickupTime}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupTime && <div className="invalid-feedback">{errors.pickupTime}</div>}
                                    </div>
                                </>
                            )}

                            {(transactionType === 'card' || transactionType === 'bank') && (
                                <div className="form-group">
                                    <label htmlFor="attachments"><span style={{ color: 'red' }}>*</span> Attachments</label>
                                    <input
                                        type="file"
                                        id="attachments"
                                        name="attachments"
                                        className={`dc-form-control ${errors.attachments ? 'is-invalid' : ''}`}
                                        multiple
                                        onChange={handleFileSelect}
                                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                    />
                                    {errors.attachments && <div className="invalid-feedback">{errors.attachments}</div>}

                                    {/* File Preview Section */}
                                    {selectedFiles.length > 0 && (
                                        <div className="mt-3">
                                            <h6>Selected Files:</h6>
                                            <div className="selected-files-list">
                                                {selectedFiles.map((file, index) => (
                                                    <div key={index} className="selected-file-item" style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        padding: '8px',
                                                        margin: '4px 0',
                                                        backgroundColor: '#f8f9fa',
                                                        borderRadius: '4px'
                                                    }}>
                                                        <span style={{ flex: 1 }}>{file.name}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveFile(index)}
                                                            className="btn btn-sm btn-danger"
                                                            style={{ marginLeft: '8px' }}
                                                        >
                                                            <i className="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="form-group">
                                <label htmlFor="amount"><span style={{ color: 'red' }}>*</span> Amount</label>
                                <input
                                    type="number"
                                    id="amount"
                                    name="amount"
                                    className={`dc-form-control ${errors.amount ? 'is-invalid' : ''}`}
                                    placeholder="₹"
                                    required
                                    min="0"
                                    step="0.01"
                                    value={income.amount}
                                    onChange={handleInputChange}
                                />
                                {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="notes">Notes</label>
                                <textarea
                                    id="notes"
                                    name="notes"
                                    className="dc-form-control"
                                    rows="4"
                                    placeholder="Enter any additional notes"
                                    value={income.notes}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="dc-btn dc-update-servicess"
                                    style={{ width: '100%' }}
                                    disabled={isUploading}
                                >
                                    {isUploading ? 'Uploading...' : 'Update Income'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '44px',
        maxHeight: '44px',
        width: '100%',
        minWidth: '200px',
        borderColor: '#4e5779',
        boxShadow: 'none',
        backgroundColor: '#ffffff',
        '&:hover': {
            borderColor: '#4e5779'
        }
    }),
    input: (provided) => ({
        ...provided,
        color: '#000000',
        margin: '0px'
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000000'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#666666',
        margin: '0px'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        backgroundColor: '#ffffff'
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#4e5779' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#000000',
        '&:hover': {
            backgroundColor: '#4e5779',
            color: '#ffffff'
        }
    })
};

export default EditIncomModel;

